/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credits_TitleInputs */

const en_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Credits and AI Usage`)
};

const de_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Credits und KI-Nutzung`)
};

const fr_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Crédits et utilisation de l'IA`)
};

const es_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Créditos y uso de IA`)
};

const it_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Crediti e utilizzo dell'AI`)
};

const nl_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Credits en AI-gebruik`)
};

const pl_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kredyty i korzystanie z AI`)
};

const fi_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Krediitit ja tekoälyn käyttö`)
};

const da_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kreditter og AI-brug`)
};

const sv_agb_credits_title = /** @type {(inputs: Agb_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Krediter och AI-användning`)
};

/**
* | output |
* | --- |
* | "6. Credits and AI Usage" |
*
* @param {Agb_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credits_title = /** @type {((inputs?: Agb_Credits_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credits_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credits_title(inputs)
	if (locale === "fr") return fr_agb_credits_title(inputs)
	if (locale === "es") return es_agb_credits_title(inputs)
	if (locale === "it") return it_agb_credits_title(inputs)
	if (locale === "nl") return nl_agb_credits_title(inputs)
	if (locale === "pl") return pl_agb_credits_title(inputs)
	if (locale === "fi") return fi_agb_credits_title(inputs)
	if (locale === "da") return da_agb_credits_title(inputs)
	if (locale === "sv") return sv_agb_credits_title(inputs)
	return en_agb_credits_title(inputs)
});